import { Api } from 'utils';

class InformationService {
	
	static get = async (params?: any) => Api.createResponse('client/information',params);
	static save = async (params?: any) => Api.createResponse('client/information/save',params);
	static delete = async (params?: any) => Api.createResponse('client/information/delete',params);
	static updateCompanyName = async (params?: any) => Api.createResponse('client/information/update-company-name',params);
	static getData = async (params?: any) => Api.createResponse('client/information/data',params);

}

export default InformationService;